import { RegisterProvisionalCompanyWithBizsolMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerProvisionalCompanyWithBizsolHandler =
  graphql.mutation<RegisterProvisionalCompanyWithBizsolMutation>(
    "registerProvisionalCompanyWithBizsol",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerProvisionalCompanyWithBizsol: true,
        },
      });
    }
  );
